import styled from 'styled-components'
import { colors, device } from 'Styled/variables'
import { VideoStatus } from 'Constants/enums'

interface Props {
  status: string
}

interface PropsBool {
  textareaRejectState: boolean
}

const handleStatusColor = (status: string) => {
  switch (status) {
    case VideoStatus.ACCEPTED:
      return colors.messegesYellow1

    case VideoStatus.AWAITING_REVIEW:
    case VideoStatus.AWAITING_MODERATOR_REVIEW:
      return colors.messegesGreen1

    case VideoStatus.APPROVED_AUTOMATICALLY:
    case VideoStatus.APPROVED_BY_ARTIST:
    case VideoStatus.APPROVED_BY_ADMIN:
      return colors.green

    case VideoStatus.CANCELED:
    case VideoStatus.CANCELED_BY_ARTIST:
    case VideoStatus.DECLINED:
      return colors.messegesRed

    default:
      return colors.green
  }
}

export const Card = styled.div`
  display: grid;
  align-items: flex-start;
  gap: 20px;
  padding: 16px;
  background-color: ${colors.white};
  margin-bottom: 10px;
  @media ${device.smallScreen} {
    grid-template-columns: 256px 1fr;
    gap: 24px;
    padding: 24px;
    background-color: ${colors.errorBg};
    margin-bottom: 2px;
  }
`

export const PersonalInfo = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 16px;
`

export const StyledBlock = styled.div`
  display: grid;
  color: ${colors.mainText};
`

export const StyledName = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
`
export const Stars = styled.div`
  line-height: 14px;
  margin-bottom: 0px;
  @media ${device.smallScreen} {
    margin-bottom: 4px;
  }
`

export const Followers = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 7.5px;
  @media ${device.smallScreen} {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 13px;
  }
`

export const Divider = styled.hr`
  border-color: ${colors.greyBlue};
  margin: 0;
  width: 100%;
  @media ${device.smallScreen} {
    display: none;
  }
`

export const VideoInfo = styled.div`
  display: grid;
  gap: 22px;
  @media ${device.smallScreen} {
    gap: ${(props: PropsBool) => (props.textareaRejectState ? '24px' : '33px')};
  }
`

export const TopBar = styled.div`
  display: grid;
  @media ${device.smallScreen} {
    grid-template-columns: 150px 150px 1fr;
  }
`

export const StyledImg = styled.img`
  border-radius: 50%;
  width: 100%;
  object-fit: cover;
`
export const Profile = styled.a`
  width: 83px;
  text-decoration: none;
  color: ${colors.mainText};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  border: none;
  border-bottom: 1px dashed ${colors.mainText};
  background-color: transparent;
  outline: none;
  &:hover {
    background: transparent;
    color: ${colors.mainText};
  }
  &:visited {
    background: transparent;
    color: ${colors.mainText};
  }
`

export const StyledTitle = styled.div`
  color: ${colors.mainText};
  font-size: 10px;
  line-height: 15px;
`

export const BtnWrappper = styled.div`
  display: grid;
  margin-top: 16px;
  @media ${device.mobileMin} {
    display: block;
    margin-top: 0px;
    text-align: right;
  }
`

export const StyledLink = styled.a`
  color: ${colors.green};
  &:hover {
    color: ${colors.green};
  }
  &:visited {
    color: ${colors.green};
  }
`

export const BtnContainer = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-columns: 12px 1fr;
  gap: 10px;
`

export const Status = styled.div`
  margin-bottom: 8px;
  color: ${(props: Props) => handleStatusColor(props.status)};
  @media ${device.smallScreen} {
    margin-bottom: 0px;
  }
`

export const StyledBtn = styled.button`
  padding: 0px;
  width: 82px;
  text-decoration: none;
  justify-content: center;
  text-align: center;
  color: ${colors.mainText};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  border: none;
  border-bottom: 1px dashed ${colors.mainText};
  background-color: transparent;
  outline: none;
  margin-bottom: 9px;
`

export const SubTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 8px;
`

export const Minutes = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const RejectWrapper = styled.div`
  display: grid;
`
export const StyledCancel = styled.button`
  padding: 0px;
  width: 42px;
  text-decoration: none;
  color: ${colors.mainText};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  border: none;
  border-bottom: 1px dashed ${colors.mainText};
  background-color: transparent;
  outline: none;
  // @media ${device.smallScreen} {
  //   order: -1;
  // }
`

export const BtnsWrappper = styled.div`
  display: grid;
  align-items: center;
  gap: 16px;
  justify-items: center;
  justify-content: center;
  padding-top: 8px;
  grid-column-start: 1;
  @media ${device.mobileMin} {
    justify-content: right;
    gap: 16px;
    text-align: right;
    grid-template-columns: 42px 130px;
    grid-column: 1 / -1;
  }
`

export const BtnsRateWrappper = styled.form`
  display: grid;
  padding-top: 8px;

  @media ${device.mobileMin} {
    gap: 16px;
    grid-template-columns: 1fr 111px;
  }
`
